import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

export const WORKSPACE_AGENT_PANEL_OPENED_LOCATIONS = [
  'announcement',
  'header',
  'toolbar',
  'asset_modal',
  'fab',
  'url',
  'selection_menu',
  'edit_tags_modal',
  'board_menu',
] as const;

export type WorkspaceAgentPanelOpenedLocation = (typeof WORKSPACE_AGENT_PANEL_OPENED_LOCATIONS)[number];

const META: Meta = {
  description: 'The workspace agent panel expands from minimized',
  name: 'agent_panel_opened',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description:
        'The UI surface the user opened the panel from, including announcement commands, hero launches from selection menus, the edit-tags modal promo, or the Board templates item in a board right-click menu',
      name: 'location',
      required: true,
      type: 'enum',
      values: [...WORKSPACE_AGENT_PANEL_OPENED_LOCATIONS],
    },
  ],
};

export default META;
